import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AccountingAccountModel} from '../../../api/entity/accountingAccount.model';
import {AbstractRepositoryV2} from '../../../../../core/service/v2/abstractRepositoryV2';


@Injectable({providedIn: 'root'})
export class AccountingAccountRepository extends AbstractRepositoryV2<AccountingAccountModel>{
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('AccountingAccount', serviceElementsFactory, injector);
    }
}
